import clsx from 'clsx';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const Item = _ref => {
  let {
    name,
    className,
    activeClassName,
    isActive = false,
    onClick = () => undefined
  } = _ref;
  return /*#__PURE__*/_jsx("li", {
    className: clsx(styles.item, isActive ? styles['item--active'] : '', className || '', isActive && activeClassName || ''),
    onClick: onClick,
    children: name
  });
};

export default Item;